<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
              <PaymentForm class="form-horizontal">
              <div class="form-section form-section--flex">
              <div class="main-donation">
                  <FormSection title="Donation Amount">
                    <FormRow inline>
                      <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/>
            </FormRow>                  
                      <div class="donateion__list">
                          <AmountSelector/>                    
                          <ErrorLabel field="amount" />
                      </div>
                          <ShortNote/>      
                  </FormSection>
                  <FormSection title="Donation Designation">
            <FormRow inline>
              <FormCol field="applications.0.department" width="half" :showLabel="false">
                <FormSelect>
                  <option value="Yachad">General Donation</option>
                  <option value="Yachad_NewYork">New York</option>
                  <option value="Yachad_NewJersey">New Jersey</option>
                  <option value="Yachad_NewEngland">New England</option>
                  <option value="Yachad_Baltimore">Baltimore</option>
                  <option value="Yachad_Florida">South Florida</option>
                  <option value="Yachad_Chicago">Chicago</option>
                  <option value="Yachad_Cleveland">Cleveland</option>
                  <option value="Yachad_LosAngeles">Los Angeles</option>
                  <option value="Yachad_Toronto">Toronto</option>
                  <option value="Yachad_Israel">Israel</option>
                  <option value="Yachad_Summer">Summer</option>
                  <!-- <option value="JLIC_Binghamton">JUF</option> -->
                  <option value="Yachad_Reach">Reach</option>
                  <option value="Yachad_IVDU">IVDU</option>

                </FormSelect>
              </FormCol>
            </FormRow>
            <FormSection v-if="form.amount" title="">
                    <TransactionFee />
                </FormSection>
          </FormSection>
 
                  <FormSection title="Donation Frequency">
                    <DonationFrequency />               
                  </FormSection>

                  <FormSection title="Personal Info">
                      <FormRow inline>      
                          <FormCol field="title" :flex="1" />
                          <FormCol field="firstName" :flex="2" />
                          <FormCol field="lastName" :flex="2" />
                      </FormRow>
                      <FormRow inline>
                          <FormCol field="email" />
                          <FormCol field="phone" />
                      </FormRow> 
                      <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow>                       
                      <FormRow>
                      <FormLabel>
                          <NewsletterSubscribe text="Please Send Me Email Updates From Yachad And The Orthodox Union" />
                      </FormLabel>
                    </FormRow>   
                  </FormSection>
                    <FormSection title="" v-if="form.amount && Number(form.amount) > 8">
                    <div class="inhonor">
                      <InHonorOf />
                    </div>
                  </FormSection> 
                  <FormSection title="Billing Information" >
                      <DonorAddress />
                  </FormSection>
                    <FormSection title="Payment Information" last>
                      <FormRow>
                      <Receipt :receipts="['canadian', 'us']" />
                    </FormRow> 
                    <br>
                        <FormRow inline>
                        <FormCol field="card" :showLabel="false"/>
                        </FormRow>
                    </FormSection>
                    </div>

                   </div>
                  <PaymentButton showAmount btnText="make donation"/>
              </PaymentForm>
                  </div>
                  <div class="form__tax">Tax ID: 135623717</div>
                  </div>
  </div>
  </template>
  
  <script lang="ts">
  import { onMounted } from 'vue'
  import { defineComponent } from 'vue'
  import { usePaymentForm } from '~/shared/use-payment-form'
  import { queryParams } from '~/shared/query-params'
  
  export default defineComponent({
    props: {
      subCampaign: String,
    },
    setup(props) {
      const { setValue, form, submit } = usePaymentForm()
  
      if (props.subCampaign) {
        setValue('applications.0.subCampaign', props.subCampaign)
      }
  
      onMounted(() => {
        const params = queryParams()
  
        if (params.utm_content) {
          let utmContent = params.utm_content

          // Handle misspelled "Telemarketin" (missing the "g")
          if (utmContent === 'Telemarketin' || utmContent === 'telemarketin') {
            utmContent = 'Telemarketing'
          }

          if (
            !['Direct Mail', 'Telemarketing', 'Text SMS Message'].includes(
              utmContent
            )
          ) {
            throw new Error('Invalid subcampaign')
          }
  
          setValue('applications.0.subCampaign', utmContent)
        }
      })
  
      return {
        form,
        submit,
      }
    },
  })
  </script>
  <style scoped lang="scss">
  
  h2.payment-heading {
    display: flex;
    justify-content: space-between;
  }
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }
  .fee-total {
    margin-bottom: 0;
    justify-content: space-between;
  }
  .form-container.ou-donation-form{
    margin: 0px auto;
    padding: 0px 10px;
    max-width: 100%;
    @media only screen and (min-width: 940px) {
      max-width: 1200px;
    padding: 80px;
    box-shadow: 0 0 15px #efefef;
    }
  }
  
  ::v-deep .ou-donation-form{

    label{
      margin-bottom: 0px !important;
      text-transform: none;
      color: #000;
      font-weight: 400;
      font-size: 14px;
    }
    label.radio-inline {
      display: flex;
      gap: 5px;
      padding-bottom: 4px;
    }
  
      .styled-radio-container.styled-radio-container--ou-donation.row{
        .radio-part{
          @media only screen and (min-width: 720px) {
            min-width:200px;
            max-width: 200px;
          }
        }
      }
  
  
   hr {
    margin-bottom: 45px;
    padding-bottom: 10px;
    border-top: none;
    border-bottom: 1px solid #efefef;
    }
  
    button.ou-donation-btn.btn-flex{
          margin: 0px;
      background: #ee6f1f;
      width: 250px;
      max-width: 100%;
      text-transform: uppercase;
      text-align: center;
      color: white;
      border:none;
      padding: 15px 0px;
      font-weight: 600;
      letter-spacing: 1px;
      -webkit-box-shadow: 0 0 10px #ddd;
      box-shadow: 0 0 10px #ddd;
      cursor: pointer;
      display: inline-flex;
      justify-content: center;
    }
  }
  
  ::v-deep h2{
        color: #214ba7;
      text-transform: capitalize;
    margin-top:0px;
    font-size: 16px;
    margin-bottom: 10px;
    font-weight: 700;
    @media only screen and (min-width: 720px){
      font-size: 18px;
    }
  }
  .form-section {
      margin-bottom: 30px;
      padding: 30px 0px;
      margin: 0px auto 25px;
  
      @media only screen and (min-width: 720px){
      padding: 0px 0px 30px;
      max-width: 1200px;
      background: white;
    }
  
    &.form-section--flex {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: reverse;
      -ms-flex-flow: column-reverse;
      flex-flow: column-reverse;
      padding-bottom: 0px;
      margin-bottom: 0px;
      gap: 40px;
  
          @media only screen and (min-width: 720px){

          }
          @media only screen and (min-width: 940px){
            gap: 0px;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
            -ms-flex-flow: row;
            flex-flow: row;
          }
      }
  
      .form-section__inner{
        max-width: 700px;
      }
  }
  
  .main-donation{
            @media only screen and (min-width: 940px){
               width: 60%;
                margin-right: 5%;
            }
  }
  .dd-plugin{
    @media only screen and (min-width: 940px){
               width: 45%;
               margin-bottom: 50px;
            }
  }

  ::v-deep .styled-radio-container--ou-donation.styled-radio-container{
    .amount-row{
      min-width: 100%;
    max-width: 100%;
      @media only screen and (min-width: 720px){
      min-width: 100%;
    max-width: 100%;

    &.amount_other__wrapper{
      min-width: 49%;
    max-width: 49%;
    }
      }

      .label-description{
        font-size: 14px;
        text-transform: none;
       
      }
    }

    input[type="radio"] + label {
      color: black;
    }

     input[type="radio"]:checked + label .label-amount{
      background: #15329d;
      border-right-color: gray !important;
    border-color: #15329d;
    }
   input[type="radio"]:checked + label {
    background: #15329d;
    color: white;
    }
  }
::v-deep .inhonor{
.form-group{
  display: flex;
}
  }

::v-deep .donateion__list{
  .label-amount{
    min-width: 90px;
    max-width: 90px;
  }
}
.form__tax{
  text-align: center;
    font-size: 15px;
    font-style: italic;
    padding-top: 33px;

}
  </style>
  
  